import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProcedureMoveAppBar from "../../../common/ProcedureMoveAppBar";
import Snackbar from "../../../common/Snackbar";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml";
import {
  copyElement,
  copyProcedure,
  getAllSectionsForPart,
  moveSection,
} from "../../../redux/sectionSlice";
import { generateSHA256 } from "../../../util/generateSHA256";
import {
  getAllAttachmentsForStep,
  getAllAttachmentsForSubstep,
  getAllCanvasesForStep,
  getAllCanvasesForSubstep,
  getAllFormsForStep,
  getAllFormsForSubstep,
  getAllRichTextsForStep,
  getAllRichTextsForSubstep,
  getAllStepsForSection,
  getAllSubstepsForStep,
  getAllVideosForStep,
  getAllVideosForSubstep,
} from "../../../redux/stepSlice";
import { getPages } from "../plugins/utils";
import {
  applyTransparency,
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../../SectionElements/plugins/utils.js";
import RectangleElement from "../../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import { renderPreview, renderVideo } from "../plugins/utils";
import {
  generateSourceTreePath,
  generateTargetTreePath,
  getDisplayIndex,
  getSubstepLetter,
  generateStatusText,
  validateAndCorrectTreePathData,
  generateCompleteTreePath,
} from "../../SubassemblyDetails/utils/treePathUtils";
import {
  extractVersionStructure,
  getAuditTrailData,
} from "../../../util/getAuditTrailData.js";
import { getRevAllNodes } from "../../../redux/procedureRevisionSlice.js";
const ProcedureCopyPreview = () => {
  const { sections } = useSelector((state) => state.section);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;
  let substepCounter = 1;
  let stepCounter = 1;
  const [isLoading, setIsLoading] = useState(false);
  const [isProcedureSelected, setIsProcedureSelected] = useState(false);
  const [sectionStatus, setSectionStatus] = useState("Pending");
  const [auditData, setAuditData] = useState({
    user_ref: localStorage.getItem("user_id") || "",
    ip_address: "",
    device_info: navigator.userAgent,
    hash: generateSHA256(Math.random().toString()),
    signature: "",
  }); // Fetch IP address and generate hash
  let richTextsCounter = {};
  let attachmentCounter = 1;
  const [isModalOpen, setModalOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });
  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);
  const [stepsBySectionPreview, setStepsBySectionPreview] = useState({});

  const [selectedView, setSelectedView] = useState("new");

  const {
    moveType,
    sourceSectionIndex,
    targetSectionIndex,
    revision,
    partNumber,
    type,
    partId,
    revisionId,
    fromTreeId,
    fromSectionId,
    targetSectionData,
    fromSiblingOrder,
    section,
    steps,
    title,
    fromRevisionId,
    fromPartId,
    status,
    toType,
    description,
    toPartNumber,
    treeNode,
    toRevisionId,
    fromRevision,
  } = location.state;
  const [previewSections, setPreviewSections] = useState([...sections]);

  // State variables to hold substeps and their child nodes for preview
  const [allSubsteps, setAllSubsteps] = useState(substepsByStep || {}); // Stores substeps keyed by stepId
  const [allRichTextsForSubsteps, setAllRichTextsForSubsteps] = useState({}); // Stores richTexts keyed by substepId
  const [allAttachmentsForSubsteps, setAllAttachmentsForSubsteps] = useState(
    {}
  ); // Stores attachments keyed by substepId
  const [allCanvasesForSubsteps, setAllCanvasesForSubsteps] = useState({}); // Stores canvases keyed by substepId
  const [allFormsForSubsteps, setAllFormsForSubsteps] = useState({}); // Stores forms keyed by substepId
  const [allVideosForSubsteps, setAllVideosForSubsteps] = useState({}); // Stores videos keyed by substepId

  useEffect(() => {
    dispatch(getAllSectionsForPart({ partId, revisionId: revisionId }));
  }, [dispatch, partId, revisionId]);

  useEffect(() => {
    if (sections.length > 0) {
      sections.forEach(async (section) => {
        await dispatch(
          getAllStepsForSection({
            partId,
            revisionId,
            sectionId: section.section_tree_node_id,
          })
        );
      });
    }
  }, [sections, dispatch, partId, revisionId]);

  useEffect(() => {
    if (Object.keys(stepsBySection).length > 0) {
      Object.entries(stepsBySection).forEach(([sectionId, steps]) => {
        steps.forEach((step) => {
          const { step_tree_node_id: stepId } = step;

          // // Fetch for step-level content
          dispatch(
            getAllRichTextsForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllFormsForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllVideosForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllAttachmentsForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllCanvasesForStep({ partId, revisionId, sectionId, stepId })
          );

          // Fetch substeps (async)
          dispatch(
            getAllSubstepsForStep({ partId, revisionId, sectionId, stepId })
          ).then((action) => {
            const substeps = action.payload?.substeps || [];
            substeps.forEach((substep) => {
              const substepId = substep.sub_step_tree_node_id;

              dispatch(
                getAllRichTextsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllFormsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllVideosForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllAttachmentsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllCanvasesForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
            });
          });
        });
      });
    }
  }, [sections, dispatch, partId, revisionId, stepsBySection]);
  const stepState = useSelector((state) => state.step); // extract once
  const sectionState = useSelector((state) => state.section); // extract once

  useEffect(() => {
    const useOriginal = selectedView === "original";
    const {
      richTextsByStep,
      attachmentsByStep,
      canvasesByStep,
      formsByStep,
      videosByStep,
      richTexts,
      attachments,
      canvases,
      forms,
      videos,
      substepsByStep,
      sections,
      stepsBySection,
    } = useOriginal ? stepState : location.state;

    // Set global content
    setAllRichTextsForSubsteps((prev) => ({ ...prev, ...richTexts }));
    setAllAttachmentsForSubsteps((prev) => ({ ...prev, ...attachments }));
    setAllCanvasesForSubsteps((prev) => ({ ...prev, ...canvases }));
    setAllFormsForSubsteps((prev) => ({ ...prev, ...forms }));
    setAllVideosForSubsteps((prev) => ({ ...prev, ...videos }));
    setAllSubsteps((prev) => ({ ...prev, ...substepsByStep }));

    if (useOriginal) {
      // 1️⃣ Just show what's already in Redux (as-is)
      setPreviewSections(sectionState.sections);
      setStepsBySectionPreview(stepsBySection);
    } else {
      // 2️⃣ Clone everything (sections + steps)
      const clonedSections = structuredClone(sections);
      const newStepsBySection = {};

      clonedSections.forEach((section) => {
        const originalSteps =
          stepsBySection[section.section_tree_node_id] || [];

        const clonedSteps = originalSteps.map((step) => {
          const stepId = step.step_tree_node_id;
          const newStepId = `${stepId}`; // or use uuid() if needed

          // Get substeps for this step
          const stepSubsteps = substepsByStep[stepId] || [];

          // Clone substeps with their content
          const clonedSubsteps = stepSubsteps.map((substep) => {
            const substepId = substep.sub_step_tree_node_id;
            return {
              ...structuredClone(substep),
              richTexts: (richTexts[substepId] || []).map((r) => ({
                ...structuredClone(r),
                rich_text_tree_node_id: `${r.rich_text_tree_node_id}`,
              })),
              attachments: (attachments[substepId] || []).map((a) => ({
                ...structuredClone(a),
                attachment_tree_node_id: `${a.attachment_tree_node_id}`,
              })),
              canvases: (canvases[substepId] || []).map((c) => ({
                ...structuredClone(c),
                canvas_tree_node_id: `${c.canvas_tree_node_id}`,
              })),
              forms: (forms[substepId] || []).map((f) => ({
                ...structuredClone(f),
                form_tree_node_id: `${f.form_tree_node_id}`,
              })),
              videos: (videos[substepId] || []).map((v) => ({
                ...structuredClone(v),
                video_tree_node_id: `${v.video_tree_node_id}`,
              })),
            };
          });

          return {
            ...structuredClone(step),
            step_tree_node_id: newStepId,
            substeps: clonedSubsteps,
            richTexts: (richTextsByStep[stepId] || []).map((r) => ({
              ...structuredClone(r),
              rich_text_tree_node_id: `${r.rich_text_tree_node_id}`,
            })),
            attachments: (attachmentsByStep[stepId] || []).map((a) => ({
              ...structuredClone(a),
              attachment_tree_node_id: `${a.attachment_tree_node_id}`,
            })),
            canvases: (canvasesByStep[stepId] || []).map((c) => ({
              ...structuredClone(c),
              canvas_tree_node_id: `${c.canvas_tree_node_id}`,
            })),
            forms: (formsByStep[stepId] || []).map((f) => ({
              ...structuredClone(f),
              form_tree_node_id: `${f.form_tree_node_id}`,
            })),
            videos: (videosByStep[stepId] || []).map((v) => ({
              ...structuredClone(v),
              video_tree_node_id: `${v.video_tree_node_id}`,
            })),
          };
        });

        newStepsBySection[section.section_tree_node_id] = clonedSteps;
      });

      setPreviewSections(clonedSections);
      setStepsBySectionPreview(newStepsBySection);
    }
  }, [selectedView]);

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirm = () => {
    setModalOpen(true);
  };

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) =>
        setAuditData((prev) => ({ ...prev, ip_address: data.ip }))
      )
      .catch((err) => console.error("Failed to fetch IP:", err));
  }, []);

  const handleConfirmSave = async () => {
    if (!comment) {
      showSnackbar("Comment is mandatory.", "error");
      return;
    }

    setIsLoading(true); // Show the page loader
    const {
      type,
      fromRevision,
      fromPartNumber,
      toType,
      toRevision,
      toPartNumber,
    } = location.state;
    const resp1 = await dispatch(
      getRevAllNodes({ partId: fromPartId, revisionId: fromRevisionId })
    );
    const resp2 = await dispatch(
      getRevAllNodes({ partId: partId, revisionId: toRevisionId })
    );
    const audit_trail_data = await getAuditTrailData({
      action: "REVISION_COPIED",
      comment: comment,
      version_content: {
        action_to_show: `Copied and replaced ${type} ${fromPartNumber} Rev ${fromRevision} into ${toType} ${toRevision} ${toPartNumber}`,
        originingalContent: extractVersionStructure(resp2.payload),
        newContent: extractVersionStructure(resp1.payload),
        rev: toRevision,
        status,
        type: toType,
        item_code_type: toType,
        partNumber: toPartNumber,
      },
    });

    const payload = {
      part_id_ref: fromPartId,
      procedure_rev_ref: fromRevisionId,
      new_part_id: partId,
      new_procedure_id: toRevisionId,

      audit_trail_data,
    };

    try {
      await dispatch(copyProcedure(payload)).unwrap();
      setModalOpen(false);
      navigate(
        `/revision-submission/${partId}/${revision}/${toType}/${toPartNumber}/${revisionId}/${description}`,
        { state: { status } }
      );
    } catch (error) {
      console.error("Error copying procedure:", error);
      showSnackbar("Error copying Document: " + error?.message, "error");
    } finally {
      setIsLoading(false); // Hide the page loader
    }
  };
  const getReorderedSections = (
    sections,
    sourceIndex,
    targetIndex,
    moveType
  ) => {
    return sections;
  };

  const reorderedPreviewSections = [...previewSections].sort((a, b) => {
    const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
    const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

    const orderCompare = compareSiblingOrders(orderA, orderB);
    if (orderCompare !== 0) return orderCompare;

    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA; // latest first
  });

  return (
    <div style={{ position: "relative" }}>
      {/* Main Page Loader */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div
              style={{
                border: "4px solid #f3f3f3",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite",
                marginBottom: "10px",
              }}
            ></div>
            <div style={{ fontSize: "16px", color: "#333" }}>
              Copying Document...
            </div>
          </div>
        </div>
      )}

      <ProcedureMoveAppBar
        showBackButton={false}
        showCancelButton={true}
        selectedView={selectedView}
        setSelectedView={setSelectedView}
        title="Please Confirm the Changes"
        buttons={[{ label: "Confirm", onClick: handleConfirm }]}
        subheadingBelowTitle={location.state.copyTitle || ""}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 20px",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
            }}
          >
            <span style={{ fontSize: "19px", fontWeight: 600 }}>
              {toType} {toPartNumber}
            </span>
            {isProcedureSelected && (
              <span
                style={{
                  marginLeft: "12px",
                  fontSize: "14px",
                  color: "#666",
                  fontStyle: "italic",
                }}
              >
                {/* (Copy to end) */}
              </span>
            )}
          </label>
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
          }}
        >
          <div>
            <strong>Status: </strong>
            <span style={{ color: "orange" }}>
              {location.state.status || status}
            </span>
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>
      <div style={{ padding: "20px" }}>
        <div style={{ marginTop: "20px" }}>
          {(reorderedPreviewSections || [])
            .sort((a, b) => {
              const orderA =
                a?.sibling_order || a?.procedure_tree?.sibling_order;
              const orderB =
                b?.sibling_order || b?.procedure_tree?.sibling_order;

              const orderCompare = compareSiblingOrders(orderA, orderB);
              if (orderCompare !== 0) return orderCompare;

              // Fallback: compare created_at
              const dateA = new Date(a?.created_at || 0);
              const dateB = new Date(b?.created_at || 0);
              return dateB - dateA; // latest comes first
            })
            .map((section, index) => {
              if (!section) return null;
              const stepsToRender =
                stepsBySectionPreview[section.section_tree_node_id] || [];
              return (
                <div
                  className="header-spacing"
                  key={section.section_tree_node_id}
                  style={{
                    margin: "20px 0",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <h2 style={{ margin: 0, fontSize: "20px" }}>
                      Section {index + 1}
                    </h2>
                  </label>
                  <hr />
                  <hr />
                  <div>{section.section_name}</div>
                  <div>{section.short_description}</div>

                  {/* Steps for this section */}
                  {(stepsToRender || []).map((step, stepIndex) => {
                    if (!step) return null;
                    const stepId = step.step_tree_node_id;
                    const sectionId = section.section_tree_node_id;
                    stepCounter++;
                    const stepsBeforeThisSection = (previewSections || [])
                      .slice(0, index)
                      .reduce(
                        (acc, s) =>
                          acc +
                          ((stepsBySectionPreview &&
                            stepsBySectionPreview[s?.section_tree_node_id]
                              ?.length) ||
                            (stepsBySection &&
                              stepsBySection[s?.section_tree_node_id]
                                ?.length) ||
                            0),
                        0
                      );
                    const globalStepNumber =
                      stepsBeforeThisSection + stepIndex + 1;
                    const substeps = substepsByStep[stepId] || [];

                    const substepLetter = String.fromCharCode(
                      65 + substeps.length
                    ); // A, B, C...

                    // Calculate media counters before navigation
                    const currentAttachmentCounter = attachmentCounter;
                    const currentVideoCounter = videoCounter;
                    const currentFormCounter = formCounter;
                    const currentCanvasCounter = canvasCounter;
                    const currentRichTextCounter = richTextCounter;

                    // Update counters for next step
                    //attachmentCounter += myAttachments.length;
                    // videoCounter += myVideos.length;
                    // formCounter += myForms.length;
                    // canvasCounter += myCanvases.length;
                    // richTextCounter += myRichTexts.length; // If you're adding one richText per step

                    richTextsCounter[stepId] = currentRichTextCounter;

                    // Fix: Use only one source of data to prevent duplication
                    const useOriginal = selectedView === "original";
                    const combinedItems = useOriginal
                      ? [
                          // Use Redux state data for original view
                          ...((richTexts && richTexts[stepId]) || []).map(
                            (item) => ({
                              ...item,
                              type: "richText",
                            })
                          ),
                          ...((forms && forms[stepId]) || []).map((item) => ({
                            ...item,
                            type: "form",
                          })),
                          ...((attachments && attachments[stepId]) || []).map(
                            (item) => ({
                              ...item,
                              type: "attachment",
                            })
                          ),
                          ...((canvases && canvases[stepId]) || []).map(
                            (item) => ({
                              ...item,
                              type: "canvas",
                            })
                          ),
                          ...((videos && videos[stepId]) || []).map((item) => ({
                            ...item,
                            type: "video",
                          })),
                        ]
                      : [
                          // Use step object data for new view (cloned data)
                          ...((step && step.richTexts) || []).map((item) => ({
                            ...item,
                            type: "richText",
                          })),
                          ...((step && step.forms) || []).map((item) => ({
                            ...item,
                            type: "form",
                          })),
                          ...((step && step.attachments) || []).map((item) => ({
                            ...item,
                            type: "attachment",
                          })),
                          ...((step && step.canvases) || []).map((item) => ({
                            ...item,
                            type: "canvas",
                          })),
                          ...((step && step.videos) || []).map((item) => ({
                            ...item,
                            type: "video",
                          })),
                        ];

                    // Filter out substeps or unwanted items (same as your current filter)
                    const filteredItems = combinedItems.filter(
                      (item) =>
                        !item.substep_id_ref && !item.sub_step_tree_node_id
                    );

                    filteredItems.sort((a, b) => {
                      const orderA =
                        a.sibling_order || a.procedure_tree?.sibling_order;
                      const orderB =
                        b.sibling_order || b.procedure_tree?.sibling_order;

                      const orderCompare = compareSiblingOrders(orderA, orderB);
                      if (orderCompare !== 0) return orderCompare;

                      // Fallback: compare created_at
                      const dateA = new Date(a.created_at);
                      const dateB = new Date(b.created_at);
                      return dateB - dateA; // latest comes first
                    });

                    return (
                      <div
                        key={stepId}
                        className="header-spacing"
                        style={{ marginTop: "20px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              gap: "8px",
                              cursor: "pointer",
                            }}
                          >
                            <h2
                              style={{
                                margin: 0,
                                color: "#333",
                                fontSize: "20px",
                              }}
                            >
                              Step {globalStepNumber}
                            </h2>
                          </label>

                          <div
                            style={{
                              color: "#888",
                              fontSize: "14px",
                              fontWeight: "normal",
                            }}
                          >
                            {generateCompleteTreePath({
                              sectionIndex: index,
                              stepIndex: globalStepNumber - 1,
                              substepIndex: undefined,
                              nodeType: undefined,
                              nodeIndex: undefined,
                            })}
                          </div>
                        </div>
                        <hr />
                        <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                        <p>
                          <p>
                            {structuredClone(step.step_details)
                              .sort(
                                (a, b) =>
                                  new Date(a.created_at) -
                                  new Date(b.created_at)
                              )
                              .map((myStep, index) => {
                                const partNumber =
                                  myStep.part_info?.part_number || "";
                                const description =
                                  myStep.part_info?.description || "";
                                const qtyText =
                                  myStep.qty && myStep.qty !== 0
                                    ? `Qty ${myStep.qty}`
                                    : "";

                                const partText = partNumber
                                  ? ` (${partNumber})`
                                  : "";

                                return (
                                  <span key={index}>
                                    {myStep.action}
                                    {partText}{" "}
                                    <RenderHtml content={description} />{" "}
                                    {qtyText}
                                    &nbsp;
                                  </span>
                                );
                              })}
                          </p>
                        </p>

                        <h4>
                          {step.bom_table_title_info?.category_name || ""}
                        </h4>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>
                                {
                                  step.part_number_column_title_ref_info
                                    ?.category_name
                                }{" "}
                              </th>
                              <th>Description</th>
                              <th>Qty Per</th>
                              <th>Unit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {step.parts_required.map((row) => (
                              <tr>
                                <td>{row.part_info.type_info.name}</td>
                                <td>{row.part_info.part_number}</td>
                                <td>
                                  <RenderHtml
                                    content={row.part_info.description}
                                  />
                                </td>
                                <td>{row.qty === 0 ? "" : row.qty}</td>
                                <td>{row.part_info?.unit_info?.unit_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Step Content */}

                        {filteredItems.map((item) => {
                          if (item.substep_id_ref || item.sub_step_tree_node_id)
                            return null;
                          switch (item.type) {
                            case "richText": {
                              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                              // render richText block here
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Rich Text {globalRichTextNumber}
                                </h2>
                              );

                              return (
                                <div
                                  className="header-spacing"
                                  key={item.rich_text_tree_node_id}
                                  style={{ marginTop: "20px" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: "5px",
                                      marginTop: "-10px",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {item.category_data?.category_name}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    <div
                                      style={{ marginTop: "-6px" }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.rich_text_content,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            case "video": {
                              const globalVideoNumber = videoCounter++; // ✅ use then increment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Video {globalVideoNumber}
                                </h2>
                              );

                              return (
                                <div
                                  className="header-spacing"
                                  key={label}
                                  style={{ marginTop: "20px" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>

                                  {renderVideo(item)}
                                  <div>{item.video_url}</div>

                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }

                            case "form": {
                              const globalFormNumber = formCounter++; // ✅ use then increment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Form {globalFormNumber}
                                </h2>
                              );
                              // render form block here
                              return (
                                <div className="header-spacing" key={label}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        marginTop: "20px",
                                      }}
                                    >
                                      {label}
                                    </label>
                                    <div
                                      className="header-spacing"
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>
                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }
                            case "canvas": {
                              const pages = getPages(item);

                              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Canvas {globalCanvasNumber}
                                </h2>
                              );
                              const shapes = item.shapes || [];

                              return (
                                <div
                                  key={label}
                                  className="header-spacing"
                                  style={{ marginTop: "40px" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <h2>{label}</h2>
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>

                                  <div>{item.short_description}</div>

                                  {/* Display all pages vertically */}
                                  <CanvasDisplay
                                    pages={pages}
                                    hasUserContent={hasUserContent}
                                    getTextStyle={getTextStyle}
                                    stripHtmlPreserveFormatting={
                                      stripHtmlPreserveFormatting
                                    }
                                    estimateKonvaTextHeight={
                                      estimateKonvaTextHeight
                                    }
                                    formatListContent={formatListContent}
                                    hasNoteContent={hasNoteContent}
                                    hasTaskContent={hasTaskContent}
                                    calculateGroupHeight={calculateGroupHeight}
                                    calculateTextBlockWidth={
                                      calculateTextBlockWidth
                                    }
                                  />
                                </div>
                              );
                            }
                            case "attachment": {
                              const attachmentList = item.attachments || [];
                              if (attachmentList.length === 0) return null;

                              //  const globalAttachmentNumber =
                              //           attachmentCounter++; // ✅ use then increment
                              const globalAttachmentNumber =
                                attachmentCounter++; // ✅ Increment here per attachment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Attachment {globalAttachmentNumber}
                                </h2>
                              );

                              return (
                                <div
                                  className="header-spacing"
                                  key={
                                    item.attachment_tree_node_id ||
                                    `attachment-${attachmentCounter}-${Date.now()}`
                                  }
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        marginTop: "20px",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      className="header-spacing"
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>
                                  <div>{item.short_description}</div>
                                  {attachmentList.map((attachment, i) => (
                                    <div key={i} style={{ marginLeft: "20px" }}>
                                      {renderPreview(attachment)}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}

                        {/* Substeps */}
                        {(selectedView === "original"
                          ? allSubsteps[stepId]
                          : step.substeps || []
                        ).map((substep, substepIndex) => {
                          const substepId = substep.sub_step_tree_node_id;

                          // Fix: Use only one source of data to prevent duplication (same logic as steps)
                          const useOriginal = selectedView === "original";
                          const combinedItems = useOriginal
                            ? [
                                // Use Redux state data for original view
                                ...(
                                  (richTexts && richTexts[substepId]) ||
                                  []
                                ).map((item) => ({
                                  ...item,
                                  type: "richText",
                                })),
                                ...((forms && forms[substepId]) || []).map(
                                  (item) => ({
                                    ...item,
                                    type: "form",
                                  })
                                ),
                                ...(
                                  (attachments && attachments[substepId]) ||
                                  []
                                ).map((item) => ({
                                  ...item,
                                  type: "attachment",
                                })),
                                ...(
                                  (canvases && canvases[substepId]) ||
                                  []
                                ).map((item) => ({
                                  ...item,
                                  type: "canvas",
                                })),
                                ...((videos && videos[substepId]) || []).map(
                                  (item) => ({
                                    ...item,
                                    type: "video",
                                  })
                                ),
                              ]
                            : [
                                // Use substep object data for new view (cloned data)
                                ...((substep && substep.richTexts) || []).map(
                                  (item) => ({
                                    ...item,
                                    type: "richText",
                                  })
                                ),
                                ...((substep && substep.forms) || []).map(
                                  (item) => ({
                                    ...item,
                                    type: "form",
                                  })
                                ),
                                ...((substep && substep.attachments) || []).map(
                                  (item) => ({
                                    ...item,
                                    type: "attachment",
                                  })
                                ),
                                ...((substep && substep.canvases) || []).map(
                                  (item) => ({
                                    ...item,
                                    type: "canvas",
                                  })
                                ),
                                ...((substep && substep.videos) || []).map(
                                  (item) => ({
                                    ...item,
                                    type: "video",
                                  })
                                ),
                              ];

                          // Filter out substeps or unwanted items (same as your current filter)
                          const filteredItems = combinedItems;

                          filteredItems.sort((a, b) => {
                            const orderA =
                              a.sibling_order ||
                              a.procedure_tree?.sibling_order;
                            const orderB =
                              b.sibling_order ||
                              b.procedure_tree?.sibling_order;

                            const orderCompare = compareSiblingOrders(
                              orderA,
                              orderB
                            );
                            if (orderCompare !== 0) return orderCompare;

                            // Fallback: compare created_at
                            const dateA = new Date(a.created_at);
                            const dateB = new Date(b.created_at);
                            return dateB - dateA; // latest comes first
                          });

                          // Global step number (same logic you already use for steps)
                          const stepsBeforeThisSection = previewSections
                            .slice(0, index)
                            .reduce(
                              (acc, s) =>
                                acc +
                                (stepsBySectionPreview[s.section_tree_node_id]
                                  ?.length ||
                                  stepsBySection[s.section_tree_node_id]
                                    ?.length ||
                                  0),
                              0
                            );
                          const globalStepNumber =
                            stepsBeforeThisSection + stepIndex + 1;

                          // Final substep label like Substep 5A
                          const substepLetter = String.fromCharCode(
                            65 + substepIndex
                          ); // A, B, C, ...

                          const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                          return (
                            <div
                              className="header-spacing"
                              key={substepId}
                              style={{ marginTop: "20px" }}
                            >
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      width: "100%",
                                    }}
                                  >
                                    <h2
                                      style={{
                                        margin: 0,
                                        color: "#333",
                                        fontSize: "20px",
                                      }}
                                    >
                                      {globalSubstepLabel}
                                    </h2>
                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber} &gt; Substep{" "}
                                      {globalStepNumber}
                                      {substepLetter}
                                    </div>
                                  </label>
                                </div>

                                <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>
                              </div>

                              {/* Substep Rich Texts */}
                              {filteredItems.map((item, itemIndex) => {
                                // Determine if this is the source item being moved (within substep)

                                switch (item.type) {
                                  case "richText": {
                                    const currentRichTextNumber =
                                      richTextCounter++;
                                    const richTextId =
                                      item.rich_text_node_id ||
                                      `rich-text-${currentRichTextNumber}`;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Rich Text {currentRichTextNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={richTextId}
                                        style={{ marginTop: "20px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section{" "}
                                            {reorderedPreviewSections.findIndex(
                                              (s) =>
                                                s.section_tree_node_id ===
                                                section.section_tree_node_id
                                            ) + 1}{" "}
                                            &gt; Step {globalStepNumber} &gt;
                                            Substep {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>

                                        <div
                                          style={{
                                            marginLeft: "5px",
                                            marginTop: "-10px",
                                          }}
                                        >
                                          {item.short_description}
                                        </div>
                                        <div
                                          style={{
                                            marginLeft: "4px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          {item.category_data?.category_name}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            marginLeft: "4px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <div
                                            style={{ marginTop: "-6px" }}
                                            dangerouslySetInnerHTML={{
                                              __html: item.rich_text_content,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    );
                                  }
                                  case "video": {
                                    const currentVideoNumber = videoCounter++;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Video {currentVideoNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.video_tree_node_id ||
                                          `video-${currentVideoNumber}`
                                        }
                                        style={{ marginTop: "20px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section{" "}
                                            {reorderedPreviewSections.findIndex(
                                              (s) =>
                                                s.section_tree_node_id ===
                                                section.section_tree_node_id
                                            ) + 1}{" "}
                                            &gt; Step {globalStepNumber} &gt;
                                            Substep {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>

                                        {renderVideo(item)}

                                        <div>{item.video_url}</div>

                                        <div>{item.short_description}</div>
                                      </div>
                                    );
                                  }

                                  case "form": {
                                    const currentFormNumber = formCounter++;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Form {currentFormNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.form_tree_node_id ||
                                          `form-${currentFormNumber}`
                                        }
                                      >
                                        <div
                                          className="header-spacing"
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section{" "}
                                            {reorderedPreviewSections.findIndex(
                                              (s) =>
                                                s.section_tree_node_id ===
                                                section.section_tree_node_id
                                            ) + 1}{" "}
                                            &gt; Step {globalStepNumber} &gt;
                                            Substep {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>
                                        <div>{item.short_description}</div>
                                      </div>
                                    );
                                  }
                                  case "canvas": {
                                    const pages = getPages(item);

                                    const currentCanvasNumber = canvasCounter++;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Canvas {currentCanvasNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.canvas_tree_node_id ||
                                          `canvas-${currentCanvasNumber}`
                                        }
                                        style={{ marginTop: "40px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <h2>{label}</h2>
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section{" "}
                                            {reorderedPreviewSections.findIndex(
                                              (s) =>
                                                s.section_tree_node_id ===
                                                section.section_tree_node_id
                                            ) + 1}{" "}
                                            &gt; Step {globalStepNumber} &gt;
                                            Substep {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>

                                        {/* Display all pages vertically */}
                                        <CanvasDisplay
                                          pages={pages}
                                          hasUserContent={hasUserContent}
                                          getTextStyle={getTextStyle}
                                          stripHtmlPreserveFormatting={
                                            stripHtmlPreserveFormatting
                                          }
                                          estimateKonvaTextHeight={
                                            estimateKonvaTextHeight
                                          }
                                          formatListContent={formatListContent}
                                          hasNoteContent={hasNoteContent}
                                          hasTaskContent={hasTaskContent}
                                          calculateGroupHeight={
                                            calculateGroupHeight
                                          }
                                          calculateTextBlockWidth={
                                            calculateTextBlockWidth
                                          }
                                        />
                                      </div>
                                    );
                                  }
                                  case "attachment": {
                                    const attachmentList =
                                      item.attachments || [];
                                    if (attachmentList.length === 0)
                                      return null;

                                    const currentAttachmentNumber =
                                      attachmentCounter++;

                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Attachment {currentAttachmentNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.attachment_tree_node_id ||
                                          `attachment-${attachmentCounter}-${Date.now()}`
                                        }
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section{" "}
                                            {reorderedPreviewSections.findIndex(
                                              (s) =>
                                                s.section_tree_node_id ===
                                                section.section_tree_node_id
                                            ) + 1}{" "}
                                            &gt; Step {globalStepNumber} &gt;
                                            Substep {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>
                                        <div>{item.short_description}</div>
                                        {attachmentList.map((attachment, i) => (
                                          <div
                                            key={i}
                                            style={{ marginLeft: "20px" }}
                                          >
                                            {renderPreview(attachment)}
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  }
                                  default:
                                    return null;
                                }
                              })}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              );
            })}
        </div>
      </div>

      {/* Snackbar */}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content_addsection">
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <h4
                style={{
                  marginLeft: "23px",
                  fontSize: "18px",
                  color: "#333333",
                }}
              >
                Confirm Copy & Replace of{" "}
                {title.trim().split(" ").slice(0, -1).join(" ")} {fromRevision}
              </h4>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                }}
                disabled={isLoading}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
            >
              <h4 style={{ fontSize: "14px" }}>
                For {partNumber} &gt; Rev {fromRevision}
              </h4>

              <p style={{ fontSize: "14px", color: "#333333" }}>
                <strong>Editor:</strong>{" "}
                <span style={{ marginLeft: "10px" }}>
                  {localStorage.getItem("user_name")}
                </span>
              </p>

              <label
                className="modal-label"
                style={{ fontSize: "14px", color: "#333333" }}
              >
                Comment
                <span className="required" style={{ marginLeft: "-1px" }}>
                  *
                </span>
              </label>
              <textarea
                className="modal-textarea"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
                disabled={isLoading}
              ></textarea>
            </div>

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                padding: "16px 24px",
                borderTop: "1px solid #e0e0e0",
                marginTop: "-10px",
                position: "relative",
              }}
            >
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: isLoading ? "not-allowed" : "pointer",
                }}
                disabled={isLoading}
              >
                Close
              </button>
              <button
                onClick={handleConfirmSave}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  opacity: isLoading ? 0.7 : 1,
                }}
                disabled={isLoading}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      <div style={{ height: "100px" }}></div>
    </div>
  );
};

export default ProcedureCopyPreview;
